import { CheckCircle2, MessageCircle } from "lucide-react";
import { clp, fmtDate, OVERNIGHT, waLink } from "@/lib/format";

export function ThankYou({ result, phone, onReset }) {
  const on = OVERNIGHT.includes(result.experience);
  const dates = on ? `${fmtDate(result.check_in)} al ${fmtDate(result.check_out)}` : fmtDate(result.check_in);
  const msg = `Hola Rachel Lodge, envié mi solicitud de reserva ${result.code}: ${result.experience_name}, ${dates}, ${result.guests} persona(s). Total ${clp(result.total)}, abono ${clp(result.deposit)}.`;
  return (
    <div className="rounded-3xl bg-white border border-border p-8 sm:p-12 text-center max-w-2xl mx-auto fade-up" data-testid="booking-thank-you">
      <CheckCircle2 className="h-14 w-14 text-[#5E6B52] mx-auto" />
      <p className="mt-6 eyebrow">Código de reserva</p>
      <p className="mt-1 font-serif text-4xl tracking-wide" data-testid="reservation-code">{result.code}</p>
      <p className="mt-6 text-base md:text-lg leading-relaxed" data-testid="thank-you-message">
        ¡Gracias por elegir Rachel Lodge! Hemos recibido tu solicitud de reserva y comprobante de transferencia. Revisaremos tu pago y nos comunicaremos contigo para confirmar tu visita. Si prefieres, también puedes escribirnos directamente por WhatsApp.
      </p>
      <p className="mt-4 text-sm text-muted-foreground">Estado: <b className="text-amber-700">Pendiente de confirmación</b> · {result.experience_name} · {dates}</p>
      <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
        <a href={waLink(phone, msg)} target="_blank" rel="noreferrer" data-testid="coordinate-whatsapp-btn"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] text-white px-6 py-3.5 font-semibold transition-opacity hover:opacity-90">
          <MessageCircle className="h-5 w-5" /> Coordinar por WhatsApp
        </a>
        <button type="button" onClick={onReset} data-testid="new-booking-btn"
          className="rounded-full border border-border px-6 py-3.5 font-semibold transition-colors hover:bg-[#F3EDE2]">
          Hacer otra reserva
        </button>
      </div>
    </div>
  );
}
